import { render, staticRenderFns } from "./SliderLayout.vue?vue&type=template&id=52458fc8&scoped=true&"
import script from "./SliderLayout.vue?vue&type=script&lang=js&"
export * from "./SliderLayout.vue?vue&type=script&lang=js&"
import style0 from "./slider-layout.scss?vue&type=style&index=0&id=52458fc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52458fc8",
  null
  
)

export default component.exports